import { Token } from "@mui/icons-material";
import { createAPI } from "../apisServer";
import { id } from "date-fns/locale";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqInstagram = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/instagram", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response; // Revert to returning the entire response
			})
			.catch((error) => {
				throw error;
			});
	},
	listAll: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/instagram/all", {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response; // Revert to returning the entire response
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/instagram/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/instagram", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	statusConnection: async function (id) {
		return apiServer
			.get(`portal/v1/instagram/${id}/status`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	profile: async function (id) {
		return apiServer
			.get(`portal/v1/instagram/${id}/profile`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	Token: async function (code, state) {
		return apiServer
			.post(
				"portal/v1/instagram/token",
				{ code, id_instagram: state },
				{
					headers: {
						banco,
					},
				},
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	UpdateStatus: async function (data) {
		return apiServer
			.post("portal/v1/instagram/status", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqInstagram;
